const RECENT_SEARCHES_KEY = "recentSearches"
const MAX_RECENT_ITEMS = 5

export function recentSearches() {
  return JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY)) || []
}

export function addItemToRecentSearches(value) {
  const inputValue = value.trim()
  const items = recentSearches().slice(0, MAX_RECENT_ITEMS - 1)

  if (items.includes(inputValue)) return

  if (inputValue.length > 0) {
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify([inputValue, ...items]))
  }
}

export function hide(elements) {
  elements.forEach((el) => el.classList.add("hidden"))
}

export function show(elements) {
  elements.forEach((el) => el.classList.remove("hidden"))
}

export function createCopyWithText(node, text) {
  const copy = node.cloneNode(true)
  copy.classList.remove("hidden")
  copy.querySelector("span").textContent = text
  return copy
}

export function openRecentSearch(form_id, event) {
  this.inputTarget.value = event.target.querySelector("span").textContent
  document.getElementById(form_id).requestSubmit()
}

export function fillRecentSearches() {
  const children = this.recentTilesTarget.children
  const recentSearchesTile = children[1]
  if (children.length > 2) {
    this.recentTilesTarget.replaceChildren(children[0], children[1])
  }

  recentSearches()
    .reverse()
    .forEach((text) => recentSearchesTile.after(createCopyWithText(recentSearchesTile, text)))
}

export function parseFiltersFromUrl(pathname, filterName, value) {
  const filters = pathname.split("/").slice(2)
  const filterIndex = filters.findIndex((el) => el === filterName)
  if (filterIndex === -1) return

  const values = filters[filterIndex + 1]

  return values.split("+").some((el) => el === value)
}
